import type { ProjectDailyReportDisplayStatus } from '@/types/project-daily-report';

export const PROJECT_DAILY_REPORT_STATUS_LABELS: Record<ProjectDailyReportDisplayStatus, string> = {
  NOT_SUBMITTED: '未提交',
  SUBMITTED: '已提交',
  REVIEWED: '已读',
  COMMENTED: '已评论',
};

export function projectDailyReportStatusTagColor(
  status: ProjectDailyReportDisplayStatus,
): string {
  switch (status) {
    case 'SUBMITTED':
      return 'processing';
    case 'REVIEWED':
      return 'success';
    case 'COMMENTED':
      return 'purple';
    default:
      return 'default';
  }
}
